import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { MembershipEntity } from '../../../../entities/mdqx/doctor/membership.entity';
import { MembershipActions } from '../../../actions/mdqx/doctor/membership.actions';

export const MEMBERSHIP_FEATURE_KEY = 'membership';

export interface MembershipState extends EntityState<MembershipEntity> {
    fetched: boolean;
    // latestUpdatedAt: Date | null;
}

const adapter = createEntityAdapter<MembershipEntity>({
    selectId: (Entity) => Entity.Id,
    sortComparer: (a, b) => a.Name.localeCompare(b.Name),
});

const initialState: MembershipState = adapter.getInitialState({
    fetched: false,
    // latestUpdatedAt: null,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export const membershipReducer = createReducer(
    initialState,
    on(MembershipActions.loadSuccess, (state, { Payload }) =>
        adapter.setAll(Payload, {
            ...state,
            fetched: true,
        }),
    ),
    on(MembershipActions.putSuccess, (state, { Payload }) =>
        adapter.setMany(Payload, {
            ...state,
        }),
    ),
    on(MembershipActions.changeSuccess, (state, { Payload }) =>
        adapter.setOne(Payload, {
            ...state,
        }),
    ),
    on(MembershipActions.deleteSuccess, (state, { Payload }) =>
        adapter.removeOne(Payload, {
            ...state,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllMembership = selectAll;
export const selectMembershipEntities = selectEntities;

export const selectMembershipFetched = (state: MembershipState) => state.fetched;
// export const selectMembershipLatestUpdatedAt = (state: MembershipState) => state.latestUpdatedAt;
